"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _label = _interopRequireWildcard(require("./label"));

var _classnames = _interopRequireDefault(require("classnames"));

var _textfield = _interopRequireDefault(require("./textfield.scss"));

var _field = require("./field");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function formatNumber(number) {
  var parts = number.match(/.{1,4}/g);
  return parts ? parts.join(' ') : '';
}

function isNavigationKey(event) {
  if (event.shiftKey || event.metaKey || [8, 37, 38, 39, 40, 45, 36, 35].indexOf(event.keyCode) !== -1) {
    return true;
  }

  return false;
}

function isOkKey(event) {
  if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
    return false;
  }

  return true;
}

var CreditCardField = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CreditCardField, _Component);

  function CreditCardField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, CreditCardField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(CreditCardField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      value: _this.props.value
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event) {
      if (isNavigationKey(event) || isOkKey(event)) {
        return true;
      } else {
        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (event) {
      _this.setValueFormatted(event.target.value);

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(CreditCardField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value && prevProps.value !== this.props.value) {
        this.setValueFormatted(this.props.value);
      }
    }
  }, {
    key: "setValueFormatted",
    value: function setValueFormatted(value) {
      var unspaced = value.replace(/\s+/g, '');
      this.setState({
        value: formatNumber(unspaced)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id || (0, _field.makeIdString)();
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_textfield["default"].CreditCardField, this.props.classNames.wrapper)
      }, _react["default"].createElement(_label["default"], {
        className: (0, _classnames["default"])(this.props.classNames.label, (0, _defineProperty2["default"])({}, _textfield["default"].errorLabel, this.props.errorMessage)),
        "for": id
      }, this.props.label), _react["default"].createElement(_label.SubLabel, {
        className: (0, _classnames["default"])(this.props.classNames.subLabel, (0, _defineProperty2["default"])({}, _textfield["default"].errorLabel, this.props.errorMessage))
      }, this.props.subLabel), _react["default"].createElement("div", {
        className: _textfield["default"].fieldIconContainer
      }, _react["default"].createElement("input", {
        type: "tel",
        name: this.props.name,
        autoComplete: "off",
        maxLength: 19,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        className: (0, _classnames["default"])(_textfield["default"].field, (0, _defineProperty2["default"])({}, _textfield["default"].fieldInvalid, this.props.errorMessage), this.props.classNames.field),
        value: this.state.value,
        id: id,
        placeholder: this.props.placeholder
      })), this.props.errorMessage && _react["default"].createElement(_errorMessage["default"], {
        message: this.props.errorMessage,
        className: this.props.classNames.errorMessage
      }));
    }
  }]);
  return CreditCardField;
}(_react.Component);

exports["default"] = CreditCardField;
CreditCardField.propTypes = _objectSpread({}, _field.textfieldPropTypes);
CreditCardField.defaultProps = {
  placeholder: 'xxxx xxxx xxxx xxxx',
  classNames: {}
};